import { Condimento } from './../condimento.model';
import { Ingrediente } from './../ingrediente.model';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AuthService } from './../../../shared/auth/auth.service';
import { PlatosService } from './../platos.service';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  OnDestroy,
} from '@angular/core';
import { Plato } from '../plato.model';
import { NgForm } from '@angular/forms';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import * as exifr from 'exifr';

@Component({
  selector: 'app-edit-plato',
  templateUrl: './edit-plato.component.html',
  styleUrls: ['./edit-plato.component.scss'],
})
export class EditPlatoComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public items = [1, 2, 3, 4, 5];
  private ingredientesEmpty = true;
  private condimentosEmpty = true;
  private imagenesEmpty = true;
  public showEvolucionDe = false;
  public isLoading = true;
  public edited = false;
  public imageLoading = false;
  public mode = '';
  public errorMessage = '';
  public dietas: any;
  public horarios: any;
  public estaciones: any;
  public pertenencias: any;
  public tecnicasCoccion: any;
  public tiposAlimento: any;
  public tiposImagenes: any;
  public ingredientes: any;
  public ingredientesDescription: any;
  public condimentos: any;
  public condimentosDescription: any;
  public platos: any;
  public originalPlatos: any;
  public parentIdFocus = false;
  @ViewChild('platosSelectList', { static: false })
  platosSelectList!: ElementRef;
  public platosFilterText: any;
  // public imagePreview: any[] = [];
  public plato: Plato = {
    plato_id: '',
    plato_description: '',
    plato_date: '',
    plato_date_full: '',
    url_slug: '',
    created_by: '',
    modified_by: '',

    parent_id: 'null',
    parent_text: '',

    horario_id: '',
    custom_horario: '',
    dieta_id: '',
    custom_dieta: '',
    estacion_id: '',
    tecnicas: [],
    ingredientes: [
      { ingrediente_id: null, ingrediente_description: '', tipo_id: 1 },
    ],
    condimentos: [
      { condimento_id: null, condimento_description: '', tipo_id: 1 },
    ],
    images: [{ image_path: null, preview: null, tipo_id: 1, sort_id: 1 }],

    latitud: '',
    longitud: '',
    ciudad: '',
    pais: '',
  };

  constructor(
    private platosService: PlatosService,
    private authService: AuthService,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    // alert('Unsubscribing. Elementos:, ' + this.subscriptions.length);
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    window.scroll(0, 0);
    this.subscriptions.push(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        if (paramMap.has('url_slug')) {
          this.mode = 'edit';
          this.getPlatoDetails(paramMap);
        } else {
          this.mode = 'create';
        }
      })
    );
    this.initializeSelects();
    // this.isLoading = false;
  }

  private getPlatoDetails(paramMap: ParamMap): void {
    this.subscriptions.push(
      this.platosService.getPlato(paramMap.get('url_slug') || '').subscribe(
        (response) => {
          // console.log('Plato a editar: ', response);
          this.plato = response[0];
          if (!this.plato) {
            this.router.navigate(['/platos'], {
              state: {
                data: 'Lo sentimos, no se ha podido encontrar el plato especificado.',
              },
            });
          }
          if (this.plato.plato_id) {
            this.getImagenes(this.plato.plato_id);
          }
          this.plato.parent_id =
            this.plato.parent_id &&
            this.plato.parent_id !== '0' &&
            this.plato.parent_id !== 'null'
              ? this.plato.parent_id
              : 'null';
          setTimeout(() => {
            this.isLoading = false;
          }, 50);

          const date = this.plato.plato_date;
          this.plato.plato_date_full = new NgbDate(
            Number(date.substr(0, 4)),
            Number(date.substr(5, 2)),
            Number(date.substr(8, 2))
          );
          // this.plato.images = response[0].image_path;
          // this.imagePreview = environment.imageBaseURL + this.plato.images;
          console.log(
            'this.plato.plato_date_full: ',
            this.plato.plato_date_full
          );

          this.subscriptions.push(
            this.platosService
              .getTecnicasByPlato(this.plato.plato_id)
              .subscribe(
                (result) => {
                  // console.log('Tecnicas from DB: ', result);
                  this.plato.tecnicas = result;
                },
                (error) => {
                  console.log(error);
                }
              )
          );
          this.subscriptions.push(
            this.platosService
              .getIngredientesByPlato(this.plato.plato_id)
              .subscribe(
                (result) => {
                  // console.log(result);
                  this.plato.ingredientes = result;
                  if (!result || result.length === 0) {
                    this.newIngredientes();
                  } else {
                    this.plato.ingredientes = result;
                  }
                },
                (error) => {
                  console.log(error);
                }
              )
          );
          this.subscriptions.push(
            this.platosService
              .getCondimentosByPlato(this.plato.plato_id)
              .subscribe(
                (result) => {
                  // console.log(result);
                  this.plato.condimentos = result;
                  if (!result || result.length === 0) {
                    this.newCondimentos();
                  } else {
                    this.plato.condimentos = result;
                  }
                },
                (error) => {
                  console.log(error);
                }
              )
          );
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        }
      )
    );
  }

  public searchIngredientes = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2
          ? []
          : this.ingredientesDescription
              .filter(
                (v: any) => v.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
      )
    );

  public onSearchTipoIngrediente(i: number): void {
    console.log('Buscando ingrediente: ', i);
    const description = (
      document.getElementById('ingrediente_' + i) as HTMLInputElement
    ).value;
    let tipoID = null;
    tipoID = this.ingredientes.find(
      (x: {
        ingrediente_id: string;
        tipo_id: string;
        ingrediente_description: string;
      }) =>
        x.ingrediente_description.toLowerCase() === description.toLowerCase()
    );
    if (tipoID) {
      console.log('¡Coincidencia!: ', tipoID.tipo_id);
      this.plato.ingredientes[i].tipo_id = tipoID.tipo_id;
    }
  }

  public searchCondimentos = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2
          ? []
          : this.condimentosDescription
              .filter(
                (v: any) => v.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
      )
    );

  public onSearchTipoCondimento(i: number): void {
    console.log('Buscando condimento: ', i);
    const description = (
      document.getElementById('condimento_' + i) as HTMLInputElement
    ).value;
    let tipoID = null;
    tipoID = this.condimentos.find(
      (x: {
        condimento_id: string;
        tipo_id: string;
        condimento_description: string;
      }) => x.condimento_description.toLowerCase() === description.toLowerCase()
    );
    if (tipoID) {
      console.log('¡Coincidencia!: ', tipoID.tipo_id);
      this.plato.condimentos[i].tipo_id = tipoID.tipo_id;
    }
  }

  filterPlato(event: any): void {
    if (!event) {
      this.platos = this.originalPlatos;
    } // when nothing has typed*/
    if (typeof event === 'string') {
      console.log(event);
      this.platos = this.originalPlatos.filter((plato: any) =>
        plato.plato_date.toLowerCase().includes(event.toLowerCase())
      );
      if (!this.platos.length) {
        this.platos = this.originalPlatos.filter((plato: any) =>
          plato.plato_description.toLowerCase().includes(event.toLowerCase())
        );
      }
      if (!this.platos.length) {
        this.platos = this.originalPlatos.filter((plato: any) =>
          plato.horario_description.toLowerCase().includes(event.toLowerCase())
        );
      }
    }
    // this.platosSelectList.nativeElement.size = this.platos.length + 1;
  }

  private loadPlatoFromForm(form: NgForm): void {
    this.plato.plato_description = form.value.plato_description;
    this.plato.plato_date = this.ngbDateParserFormatter.format(
      form.value.plato_date_full
    );
    this.plato.url_slug = this.processURLSlug(this.plato.plato_description);
    if (this.mode === 'create') {
      this.plato.created_by = this.authService.getUserID();
    }
    this.plato.modified_by = this.authService.getUserID();
    this.plato.horario_id = form.value.horarioID;
    this.plato.custom_horario = form.value.custom_horario;
    this.plato.dieta_id = form.value.dietaID;
    this.plato.custom_dieta = form.value.custom_dieta;
    this.plato.parent_id = form.value.parentID ? form.value.parentID : null;
    this.plato.latitud = form.value.latitud;
    this.plato.longitud = form.value.longitud;
    this.plato.ciudad = form.value.ciudad;
    this.plato.pais = form.value.pais;

    if (
      !this.ingredientesEmpty ||
      (form.value.ingrediente_0 && form.value.ingrediente_0 !== '')
    ) {
      console.log('Asignando ingredientes...');
      const length = this.plato.ingredientes.length;
      let aux: Ingrediente;
      for (let i = 0, j = 0; i < length; i++, j++) {
        while (
          !form.value['ingrediente_' + j] &&
          !form.value['ingrediente_tipoID_' + j]
        ) {
          j++;
        }
        this.plato.ingredientes[i].ingrediente_description =
          form.value['ingrediente_' + j];

        aux = this.ingredientes.find(
          (item: Ingrediente) =>
            item.ingrediente_description.toLowerCase() ===
            this.plato.ingredientes[i].ingrediente_description.toLowerCase()
        );
        this.plato.ingredientes[i].ingrediente_id =
          aux && aux.ingrediente_id ? aux.ingrediente_id : null;
        this.plato.ingredientes[i].tipo_id = !isNaN(
          Number(form.value['ingrediente_tipoID_' + j])
        )
          ? Number(form.value['ingrediente_tipoID_' + j])
          : 1;
      }
      console.log('Ingredientes asignados: ', this.plato.ingredientes);
    }
    if (
      !this.condimentosEmpty ||
      (form.value.condimento_0 && form.value.condimento_0 !== '')
    ) {
      console.log('Asignando condimentos...');
      let aux: Condimento;
      for (let i = 0, j = 0; i < this.plato.condimentos.length; i++, j++) {
        while (
          !form.value['condimento_' + j] &&
          !form.value['condimento_tipoID_' + j]
        ) {
          j++;
        }
        console.log(j);
        // console.log(this.condimentos);
        console.log(this.plato.condimentos[i]);
        console.log(this.plato.condimentos[j]);
        this.plato.condimentos[i].condimento_description =
          form.value['condimento_' + j];

        aux = this.condimentos.find(
          (item: Condimento) =>
            item.condimento_description.toLowerCase() ===
            this.plato.condimentos[i].condimento_description.toLowerCase()
        );
        this.plato.condimentos[i].condimento_id =
          aux && aux.condimento_id ? aux.condimento_id : null;
        this.plato.condimentos[i].tipo_id = !isNaN(
          Number(form.value['condimento_tipoID_' + j])
        )
          ? Number(form.value['condimento_tipoID_' + j])
          : 1;
      }
      console.log('Condimentos asignados: ', this.plato.condimentos);
    }
  }

  onSubmit(form: NgForm): void {
    console.log('----------------');
    console.log(form);
    console.log(this.plato);
    if (this.validateForm(form)) {
      console.log('Formulario válido');
      console.log(form);
      console.log(this.plato);
      this.loadPlatoFromForm(form);

      console.log('Guardando plato: ', this.plato);

      let newIngredientes = [];
      let newCondimentos = [];
      let ingredientes_description = [];
      let condimentos_description = [];

      for (let i = 0; i < this.plato.ingredientes.length; i++) {
        if (this.plato.ingredientes[i].ingrediente_description) {
          ingredientes_description.push(
            this.plato.ingredientes[i].ingrediente_description
          );

          if (!this.plato.ingredientes[i].ingrediente_id) {
            newIngredientes.push(
              this.plato.ingredientes[i].ingrediente_description
            );
          }
        }
      }
      for (let i = 0; i < this.plato.condimentos.length; i++) {
        if (this.plato.condimentos[i].condimento_description) {
          condimentos_description.push(
            this.plato.condimentos[i].condimento_description
          );

          if (!this.plato.condimentos[i].condimento_id) {
            newCondimentos.push(
              this.plato.condimentos[i].condimento_description
            );
          }
        }
      }
      console.log('Ingredientes before sort: ', ingredientes_description);
      ingredientes_description = ingredientes_description.sort();
      console.log('Ingredientes after sort: ', ingredientes_description);
      console.log('Condimentos before sort: ', condimentos_description);
      condimentos_description = condimentos_description.sort();
      console.log('Condimentos after sort: ', condimentos_description);
      console.log('New ingredientes: ', newIngredientes);
      console.log('New condimentos: ', newCondimentos);

      let userHasConfirmed = true;

      if (newIngredientes && newIngredientes.length > 0) {
        userHasConfirmed = confirm(
          ingredientes_description.toString() +
            '\n\nEstos ingredientes van a ser incluidos. ¿Está seguro/a? Si no es así, puede cancelar y revisar el listado antes de continuar.' +
            '\n\nIngrediente(s) nuevo(s): "' +
            newIngredientes.toString() +
            '"'
        );
      } else {
        userHasConfirmed = confirm(
          ingredientes_description.toString() +
            '\n\nEstos ingredientes van a ser incluidos. ¿Está seguro/a? Si no es así, puede cancelar y revisar el listado antes de continuar.'
        );
      }
      if (userHasConfirmed && newCondimentos && newCondimentos.length > 0) {
        userHasConfirmed = confirm(
          condimentos_description.toString() +
            '\n\nEstos condimentos van a ser incluidos. ¿Está seguro/a? Si no es así, puede cancelar y revisar el listado antes de continuar.' +
            '\n\nCondimento(s) nuevo(s): "' +
            newCondimentos.toString() +
            '"'
        );
      } else if (userHasConfirmed && condimentos_description.toString() != '') {
        userHasConfirmed = confirm(
          condimentos_description.toString() +
            '\n\nEstos condimentos van a ser incluidos. ¿Está seguro/a? Si no es así, puede cancelar y revisar el listado antes de continuar.'
        );
      }

      if (userHasConfirmed) {
        this.isLoading = true;

        if (this.mode === 'create') {
          this.subscriptions.push(
            this.platosService.newPlato(this.plato).subscribe(
              (result) => {
                console.log('Plato almacenado con éxito: ', result);
                this.errorMessage = 'El plato ha sido añadido con éxito';
                // this.isLoading = false;
                this.edited = true;
                this.plato.plato_id = result;

                this.uploadImages(this.plato.images);
              },
              (error) => {
                this.isLoading = false;
                this.imageLoading = false;
                this.errorMessage = error.error.error.message || '';
                if (
                  this.errorMessage &&
                  this.errorMessage.includes('Duplicate entry') &&
                  this.errorMessage.includes('url_slug')
                ) {
                  this.errorMessage =
                    'La URL amigable ya existe. Por favor, especifique otra descripción.';
                }
                window.scroll(0, 0);
              }
            )
          );
        } else if (this.mode === 'edit') {
          this.subscriptions.push(
            this.platosService.updatePlato(this.plato).subscribe(
              (result) => {
                console.log('El plato ha sido actualizado con éxito.');
                this.errorMessage = 'Plato actualizado correctamente';
                // this.isLoading = false;
                this.edited = true;

                this.uploadImages(this.plato.images);
              },

              (error) => {
                this.isLoading = false;
                this.imageLoading = false;
                console.log(error);
                this.errorMessage =
                  error.error.error.message ||
                  'Lo sentimos, se ha producido un error.';
                if (
                  this.errorMessage &&
                  typeof this.errorMessage === 'string' &&
                  this.errorMessage.includes('Duplicate entry') &&
                  this.errorMessage.includes('url_slug')
                ) {
                  this.errorMessage =
                    'La URL amigable ya existe. Por favor, especifique otra descripción.';
                }
                window.scroll(0, 0);
              }
            )
          );
        }
      }
    }
  }

  private uploadImages(images: any): void {
    this.subscriptions.push(
      this.platosService.unlinkImages(this.plato.plato_id).subscribe(
        (result) => {
          console.log('Las imágenes han sido desenlazadas con éxito.');

          // console.log('Subiendo imégenenes: ', images);
          this.imageLoading = true;
          images.forEach((image: any, i: number) => {
            if (image && !image.preview) {
              images.splice(i, 1);
            }
          });
          images.forEach((image: any, i: number) => {
            if (image && image.preview) {
              this.uploadEachImage(image, i, i === images.length - 1);
            } else {
              i++;
            }
          });
        },
        (error) => {
          this.isLoading = false;
          this.imageLoading = false;
          console.log(error);
          this.errorMessage =
            error.error.error.message ||
            'Lo sentimos, se ha producido un error al subir las imágenes.';
          window.scroll(0, 0);
        }
      )
    );

    /*this.platosService
      .uploadImage(this.plato.plato_id, image, this.plato.url_slug)
      .subscribe(
        (result) => {
          console.log('El plato ha sido actualizado con éxito.');
          this.isLoading = false;
          this.edited = true;
          this.imageLoading = false;
          const message =
            this.mode === 'create'
              ? 'Plato añadido correctamente'
              : 'Plato actualizado correctamente';

          setTimeout(() => {
            this.router.navigate(['/platos'], {
              state: { data: message },
            });
          }, 3000);
        },
        (error) => {
          this.isLoading = false;
          this.imageLoading = false;
          console.log(error);
          this.errorMessage =
            error.error.error.message ||
            'Lo sentimos, se ha producido un error al subir las imágenes.';
          window.scroll(0, 0);
        }
      );*/
  }

  private uploadEachImage(image: any, id: number, isLast: boolean): void {
    this.imageLoading = true;
    console.log('Subiendo imagen: ', id, ', ', isLast);
    this.subscriptions.push(
      this.platosService
        .uploadImage(
          this.plato.plato_id,
          image.image_path,
          this.plato.url_slug,
          image.tipo_id,
          '' + (id + 1)
        )
        .subscribe(
          (result) => {
            console.log('El plato ha sido actualizado con éxito.');
            if (isLast) {
              this.isLoading = false;
              this.edited = true;
              this.imageLoading = false;
              const message =
                this.mode === 'create'
                  ? 'Plato añadido correctamente'
                  : 'Plato actualizado correctamente';

              setTimeout(() => {
                this.router.navigate(['/platos'], {
                  state: { data: message, bypassConfirmation: true },
                });
              }, 3000);
            }
          },
          (error) => {
            this.isLoading = false;
            this.imageLoading = false;
            console.log(error);
            this.errorMessage =
              error.error.error.message ||
              'Lo sentimos, se ha producido un error al subir las imágenes.';
            window.scroll(0, 0);
          }
        )
    );
  }

  onNavigate(destination: string): void {
    if (destination === 'this') {
      window.location.href = 'platos/editar/' + this.plato.url_slug;
    } else {
      // this.router.navigate(['/' + destination]);
    }
  }

  onPlatoChange(form: NgForm): void {
    /*console.log('Plato: ', this.plato);
    console.log('Form: ', form);*/
  }

  onSelectEstacion(id: string): void {
    this.plato.estacion_id = id;
  }

  onSelectTecnica(id: string): void {
    if (!this.plato.tecnicas) {
      console.log('Inicializando array...');
      this.plato.tecnicas = [];
    }
    console.log('Array original:', this.plato.tecnicas);
    const index = this.plato.tecnicas.findIndex((x) => x.tecnica_id === id);
    if (index >= 0) {
      this.plato.tecnicas.splice(index, 1);
    } else {
      this.plato.tecnicas.push({
        tecnica_id: id,
      });
    }
    console.log('Nuevo array original:', this.plato.tecnicas);
    /*
    const index = this.plato.tecnicas.indexOf(id);
    if (index >= 0) {
      console.log(
        'Eliminando elemento:' +
          index +
          'del array original: ' +
          this.plato.tecnicas
      );
      console.log('Array original:', this.plato.tecnicas);
      this.plato.tecnicas.splice(index, 1);
      console.log('Nuevo array original:', this.plato.tecnicas);
    } else {
      console.log('Añadiendo elemento: ' + id);
      this.plato.tecnicas = [...this.plato.tecnicas, id];
    }*/
  }

  isTecnicaSelected(tecnicaID: string): number {
    return this.plato.tecnicas && this.plato.tecnicas.length > 0
      ? this.plato.tecnicas.findIndex((x) => x.tecnica_id === tecnicaID)
      : -1;
  }

  private validateForm(form: NgForm): boolean {
    console.log('Validating form...');

    console.log('form.value.custom_horario: ', form.value.custom_horario);
    console.log(this.horarios);
    if (form.value.horarioID === 'other' && !form.value.custom_horario) {
      this.errorMessage = 'Por favor, especifique un horario.';
      window.scroll(0, 0);
      return false;
    }
    if (form.value.dietaID === 'other' && !form.value.custom_dieta) {
      this.errorMessage = 'Por favor, especifique una dieta.';
      window.scroll(0, 0);
      return false;
    }
    if (
      // Comprueba si el horario personalizado ya existe
      form.value.custom_horario &&
      this.horarios &&
      this.horarios.some(
        (item: any) =>
          item.horario_description.toUpperCase() ===
          form.value.custom_horario.toUpperCase()
      )
    ) {
      this.errorMessage = 'El horario especificado ya existe.';
      window.scroll(0, 0);
      return false;
    }
    if (
      // Comprueba si la dieta personalizada ya existe
      form.value.custom_dieta &&
      this.dietas &&
      this.dietas.some(
        (item: any) =>
          item.dieta_description.toUpperCase() ===
          form.value.custom_dieta.toUpperCase()
      )
    ) {
      this.errorMessage = 'La dieta especificada ya existe.';
      window.scroll(0, 0);
      return false;
    }

    return true;
  }

  private initializeSelects(): void {
    this.getDietas();
    this.getHorarios();
    this.getEstaciones();
    this.getTecnicasCocciones();
    this.getTiposAlimento();
    this.getTiposImagenes();
    setTimeout(() => {
      this.getCondimentos();
    }, 250);

    /*setTimeout(() => {
      this.getPlatos();
    }, 500);*/
    setTimeout(() => {
      this.getIngredientes();
    }, 50);
  }

  private getImagenes(platoID: string): void {
    this.subscriptions.push(
      this.platosService.getImagenes(platoID).subscribe(
        (result) => {
          // console.log(result);
          this.plato.images = result;
          for (let i = 0; i < this.plato.images.length; i++) {
            /*this.imagePreview.push(
            environment.imageBaseURL + this.plato.images[i].image_path
          );*/
            console.log('Cargando imagen: ', i);
            this.plato.images[i].preview =
              environment.imageBaseURL + this.plato.images[i].image_path;

            // console.log('Cargando imagen (preview): ', this.plato.images[i].preview);
          }
          // console.log('this.plato.images:');
          // console.log(this.plato.images);
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        }
      )
    );
  }
  private getDietas(): void {
    this.subscriptions.push(
      this.platosService.getDietas().subscribe(
        (result) => {
          // console.log(result);
          this.dietas = result;
          setTimeout(() => {
            this.isLoading = false;
          }, 250);
          // console.log('This.dietas: ' + this.dietas);
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        }
      )
    );
  }
  private getHorarios(): void {
    this.subscriptions.push(
      this.platosService.getHorarios().subscribe(
        (result) => {
          // console.log(result);
          this.horarios = result;
          this.isLoading = false;
          // console.log('This.horarios: ' + this.horarios);
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }
  private getEstaciones(): void {
    this.subscriptions.push(
      this.platosService.getEstaciones().subscribe(
        (result) => {
          // console.log(result);
          this.isLoading = false;
          this.estaciones = result;
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }
  private getTecnicasCocciones(): void {
    this.subscriptions.push(
      this.platosService.getTecnicasCoccion().subscribe(
        (result) => {
          // console.log(result);
          this.isLoading = false;
          this.tecnicasCoccion = result;
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }

  private getTiposAlimento(): void {
    this.subscriptions.push(
      this.platosService.getTiposAlimento().subscribe(
        (result) => {
          this.tiposAlimento = result;
          this.isLoading = false;
          // console.log('this.tiposAlimento: ', this.tiposAlimento);
        },
        (error) => {
          this.errorMessage = error;
        }
      )
    );
  }
  private getTiposImagenes(): void {
    this.subscriptions.push(
      this.platosService.getTiposImagenes().subscribe(
        (result) => {
          this.tiposImagenes = result;
          this.isLoading = false;
          // console.log('this.tiposimagenes: ', this.tiposImagenes);
        },
        (error) => {
          this.errorMessage = error;
        }
      )
    );
  }
  private getIngredientes(): void {
    console.log('Obteniendo ingredientes...');
    this.subscriptions.push(
      this.platosService.getIngredientes().subscribe(
        (result) => {
          this.ingredientesDescription = result.map(
            (item: { ingrediente_description: string }) =>
              item.ingrediente_description
          );
          this.ingredientes = result;
          this.isLoading = false;
          // console.log('this.ingredientes: ', this.ingredientesDescription);
        },
        (error) => {
          this.errorMessage = error;
        }
      )
    );
  }
  private getCondimentos(): void {
    this.subscriptions.push(
      this.platosService.getCondimentos().subscribe(
        (result) => {
          this.condimentosDescription = result.map(
            (item: { condimento_description: string }) =>
              item.condimento_description
          );
          this.condimentos = result;
          this.isLoading = false;
          // console.log('this.condimentos: ', this.condimentosDescription);
        },
        (error) => {
          this.errorMessage = error;
        }
      )
    );
  }
  public getPlatos(): void {
    this.showEvolucionDe = true;
    this.subscriptions.push(
      this.platosService.getAllPlatos().subscribe(
        (result) => {
          this.platos = result;
          this.originalPlatos = result;
          this.isLoading = false;
          console.log('Platos cargados para evolución de...');

          setTimeout(() => {
            this.parentIdFocus = true;
          }, 3000);
        },
        (error) => {
          this.errorMessage = error;
        }
      )
    );
  }

  processURLSlug(input: string): string {
    if (input) {
      let descripcionSlug = this.stringToSlug(input);
      if (descripcionSlug.length > 70) {
        descripcionSlug = descripcionSlug.substr(0, 70);
        descripcionSlug = descripcionSlug.substr(
          0,
          descripcionSlug.lastIndexOf('-')
        );
      }
      return (
        this.stringToSlug(
          this.ngbDateParserFormatter.format(this.plato.plato_date_full)
        ) + // date
        '-' +
        descripcionSlug
      );
    }
    return '';
  }

  private stringToSlug(input: string): string {
    if (input) {
      const trChars: any = {
        áÁ: 'a',
        éÉ: 'e',
        íÍ: 'i',
        óÓ: 'o',
        úÚ: 'u',
        ñÑ: 'n',
      };
      for (const key of Object.keys(trChars)) {
        input = input.replace(new RegExp('[' + key + ']', 'g'), trChars[key]);
      }

      return input
        .toString()
        .toLowerCase()
        .replace(/ de /g, '-')
        .replace(/ con /g, '-')
        .replace(/ y /g, '-')
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    }
    return '';
  }

  private newImagenes(): void {
    this.plato.images = [];
    this.plato.images.push({
      image_path: '',
      preview: null,
      tipo_id: 1,
      sort_id: 1,
    });
    this.imagenesEmpty = true;
  }
  private newIngredientes(): void {
    this.plato.ingredientes = [];
    this.plato.ingredientes.push({
      ingrediente_id: null,
      ingrediente_description: '',
      tipo_id: 1,
    });
    this.ingredientesEmpty = true;
  }
  private newCondimentos(): void {
    this.plato.condimentos = [];
    this.plato.condimentos.push({
      condimento_id: null,
      condimento_description: '',
      tipo_id: 1,
    });
    this.condimentosEmpty = true;
  }
  onAddImagen(): void {
    this.plato.images.push({
      image_path: '',
      preview: null,
      tipo_id: 1,
      sort_id: 1,
    });
    // console.log('Images after push: ', this.plato.images);
    this.imagenesEmpty = false;

    setTimeout(() => {
      /*console.log('imagePicker_' + (this.plato.images.length - 1));
      console.log(
        document.getElementById('imagePicker_' + (this.plato.images.length - 1))
      );*/
      document
        .getElementById('imagePicker_' + (this.plato.images.length - 1))
        ?.click();
    }, 50);
  }

  onDeleteImagen(i: number): void {
    // console.log('Images before splice: ', this.plato.images);
    this.plato.images.splice(i, 1);
    if (this.plato.images.length === 0) {
      this.newImagenes();
    }
    // this.imagePreview.splice(i, 1);

    // console.log('Image after splice: ', this.plato.images);
  }

  onAddIngrediente(form: NgForm): void {
    // console.log(form);
    // console.log('Ingredientes before push: ', this.plato.ingredientes);
    this.plato.ingredientes.push({
      ingrediente_id: null,
      ingrediente_description: '',
      tipo_id: 1,
    });
    // console.log('Ingredientes after push: ', this.plato.ingredientes);
    this.ingredientesEmpty = false;
  }

  onDeleteIngrediente(i: number): void {
    // console.log('Ingredientes before splice: ', this.plato.ingredientes);
    this.plato.ingredientes.splice(i, 1);
    if (this.plato.ingredientes.length === 0) {
      this.newIngredientes();
    }
    // console.log('Ingredientes after splice: ', this.plato.ingredientes);
  }

  onAddCondimento(form: NgForm): void {
    // console.log(form);
    this.plato.condimentos.push({
      condimento_id: null,
      condimento_description: '',
      tipo_id: 1,
    });
    this.condimentosEmpty = false;
  }

  onDeleteCondimento(i: number): void {
    this.plato.condimentos.splice(i, 1);
    if (this.plato.condimentos.length === 0) {
      this.newCondimentos();
    }

    console.log('Ingredientes after splice: ', this.plato.ingredientes);
  }

  onImagePicked(event: Event, i: number): void {
    // console.log(event);
    const fileArray: any = (event.target as HTMLInputElement).files
      ? (event.target as HTMLInputElement).files
      : null;
    if (fileArray && fileArray.length) {
      this.plato.images[i].image_path = fileArray[0];
      // console.log('this.plato.image: ', this.plato.images);
      const reader = new FileReader();
      reader.onload = () => {
        // this.imagePreview[i] = reader.result;
        this.plato.images[i].preview = reader.result;
        if (!this.plato.latitud || !this.plato.longitud) {
          this.getCoordinates(this.plato.images[i].preview);
        }
      };
      reader.readAsDataURL(this.plato.images[i].image_path);
    }
  }

  public onImageTipoIDChanged(image: any, tipoID: any): void {
    image.tipo_id = tipoID.value;
    console.log('image.tipo_id: ', image.tipo_id);
  }

  public getCoordinates(image: any): void {
    // console.log('Imagen a procesar para coordenadas PRE: ', image);
    if (
      !image &&
      this.plato.images &&
      this.plato.images[0] &&
      this.plato.images[0].image_path
    ) {
      image = '/assets' + this.plato.images[0].image_path;
    }
    // console.log('Imagen a procesar para coordenadas POST: ', image);
    if (image) {
      exifr.gps(image).then((gps) => {
        this.plato.latitud = gps.latitude.toString();
        this.plato.longitud = gps.longitude.toString();

        console.log(this.plato.latitud, this.plato.longitud);

        this.getGeolocationInfo(gps.latitude, gps.longitude);

        /*.subscribe(
            (response) => {
              console.log('GEO GMAPS response: ', response);
            },
            (error) => {
              this.errorMessage = error;
            }
          );*/
      });
    }
  }

  private getGeolocationInfo(latitude: number, longitude: number): void {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results: any) => {
        console.log('Result API', results);

        if (results[1]) {
          let country = null;
          let countryCode = null;
          let city = null;
          let cityAlt = null;
          let c;
          let lc;
          let component;
          console.log(results);
          for (let r = 0, rl = results.length; r < rl; r += 1) {
            const result = results[r];
            console.log(result);

            if (
              (!city &&
                (result.types[0] === 'locality' ||
                  result.types[0] === 'postal_code')) ||
              result.types[0] === 'plus_code' ||
              result.types[0] === 'administrative_area_level_4'
            ) {
              for (
                c = 0, lc = result.address_components.length;
                c < lc;
                c += 1
              ) {
                component = result.address_components[c];
                console.log('Component: ', component);

                if (
                  component.types[0] === 'locality' ||
                  component.types[1] === 'locality' ||
                  component.types[2] === 'locality' ||
                  component.types[0] === 'administrative_area_level_4'
                ) {
                  city = component.long_name;
                  break;
                }
              }
            } else if (
              !city &&
              !cityAlt &&
              result.types[0] === 'administrative_area_level_1'
            ) {
              for (
                c = 0, lc = result.address_components.length;
                c < lc;
                c += 1
              ) {
                component = result.address_components[c];

                if (component.types[0] === 'administrative_area_level_1') {
                  cityAlt = component.long_name;
                  break;
                }
              }
            } else if (!country && result.types[0] === 'country') {
              country = result.address_components[0].long_name;
              countryCode = result.address_components[0].short_name;
            }

            if (city && country) {
              break;
            }
          }

          console.log(
            'City: ' +
              city +
              ', City2: ' +
              cityAlt +
              ', Country: ' +
              country +
              ', Country Code: ' +
              countryCode
          );

          this.plato.ciudad = city;
          this.plato.pais = country;
        }
      }
    );
  }

  /*private fillArray(array: any[], number: number) {
    array = Array(number)
      .fill()
      .map((x, i) => i);
  }*/
}
